import React, { useState } from "react";
import './WebDesign.css';
import trafficconversions from './assets/trafficconversions.jpg';
import marketingapproach from './assets/marketingapproach.avif';
import marketingoffer from './assets/marketingoffer.avif';

const DigitalMarketing = () => {
    return (
        <>
            {/* Banner Section */}
            <section className="webdesign-section">
                <div className="webdesign-overlay">
                    <div className="webdesign-content">
                        <h1 className="webdesign-title">Digital Marketing</h1>
                        <p className="webdesign-breadcrumb">
                            <span>Dot LocalHost</span> &gt; <span>Digital Marketing</span>
                        </p>
                    </div>
                </div>
            </section>

            <div className="company-section py-5">
                <div className="container">

                    <div className="row align-items-center">
                        {/* Left Text Column */}
                        <div className="col-md-6 text-column">
                            <h2>Digital Marketing – Driving Traffic, Conversions, and Revenue</h2>
                            <p>Digital marketing is key to growing your business in today’s competitive landscape. Our Digital Marketing services are designed to help you reach your target audience, drive traffic to your site, and increase conversions. We create tailored marketing campaigns that combine SEO, pay-per-click (PPC) advertising, email marketing, and content marketing to boost brand awareness and generate leads.</p>
                            <h3>Why Digital Marketing Matters</h3>
                            <p>A strong online presence is essential for brand visibility and customer engagement. Effective digital marketing strategies ensure your business reaches the right audience at the right time, driving higher ROI and business growth.</p>
                        </div>

                        {/* Right Image Column */}
                        <div className="col-md-6">
                            <img src={trafficconversions} alt="About Us" className="img-fluid about-image" />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6 side-images py-5">
                            <img src={marketingapproach} alt="Mobile Optimization" className="mt-3" />
                        </div>
                        <div className="col-md-6 py-5">
                            <div className="content-section text-column">
                                <h3>Our Marketing Approach</h3>                                
                                <ol>
                                    <li><b>SEO Optimization:</b> Improving search rankings and organic reach.</li>
                                    <li><b>PPC & Paid Campaigns:</b> Driving targeted traffic with data-driven ads.</li>
                                    <li><b>Content Marketing:</b> Creating valuable content that engages and converts.</li>
                                    <li><b>Email & Social Media Marketing:</b> Building relationships and nurturing leads.</li>
                                </ol>
                            </div>
                        </div>                        
                    </div>

                    <div className="row">                        
                        <div className="col-md-6 py-5">
                            <div className="content-section text-column">
                                <h3>What We Offer</h3>                                
                                <ol>
                                    <li><b>SEO (Search Engine Optimization) for Organic Growth:</b> Increasing search visibility and traffic.</li>
                                    <li><b>PPC (Pay-Per-Click) Campaign Management:</b> Managing paid advertising for maximum ROI.</li>
                                    <li><b>Content Marketing Strategies that Engage and Convert:</b> Crafting Compelling Content.</li>
                                    <li><b>Email Marketing Campaigns for Nurturing Leads:</b> Strengthening customer relationships.</li>
                                </ol>
                            </div>
                        </div> 
                        <div className="col-md-6 side-images py-5">
                            <img src={marketingoffer} alt="Mobile Optimization" className="mt-3" />
                        </div>                       
                    </div>

                    <section className="hero-section text-column mt-5">
                        <p>Digital marketing is a powerful tool for growing your business. Let us help you build strategies that drive meaningful results and long-term success.</p>
                    </section>

                </div>
            </div>

        </>
    );
};

export default DigitalMarketing;